<script type="text/jsx">
/* eslint-disable vue/require-prop-types */
import AppLink from 'ui/v1/navigation/AppLink.vue';
import UiRowButton from '../controls/UiRowButton.vue';

export default {
    props: ['to', 'exact'],

    render() {
        return <AppLink
            active-class="font-semibold bg-mouse"
            class="text-3 flex items-center text-charcoal"
            to={this.to} exact={this.exact}>
            <UiRowButton
                tag="span"
                onClick={() => {
                    this.$router.push(this.to);
                }}
                class={{ 'px-xl py-xxs justify-start': true }}>
                {this.$slots.default}
            </UiRowButton>
        </AppLink>;
    },
};
</script>
